import API from './api';

/**************************************************
 IMPORTANT : ne pas utiliser directement les API
 vous devez utiliser les services à la place
 **************************************************/

const exportedObject = {

  get (id, params) {
    return API.get('/users/' + id, { params })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getAll (params) {
    return API.get('/users/', { params })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  update (id, data) {
    return API.post('/users/' + id, data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  activate (token, data = {}) {
    return API.post('/users/activate/' + token, data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  }
}

export default exportedObject;
